import styled from "@emotion/styled"
import { NewText } from "ui"

const StyledTextContent = styled.div<{
  isCentered?: boolean
  desktopMarginBottom?: number
  mobileMarginBottom?: number
}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: ${(props) => (props.isCentered ? "center" : "initial")};
  color: var(--benefits-black);
  margin-bottom: ${(props) => props.mobileMarginBottom || 0}px;

  font-family: var(--narkis-condensed) !important;
  * {
    font-family: inherit !important;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 16px;
    margin-bottom: ${(props) => props.desktopMarginBottom || 0}px;
  }
`

const StyledHeading = styled.div<{ isCentered?: boolean }>`
  font-size: 40px;
  font-weight: 400;
  line-height: 120%;
  text-align: ${(props) => (props.isCentered ? "center" : "initial")};

  > * {
    margin: 0;
    padding: 0;
    gap: 8px;
  }

  strong {
    color: ${(props) => props.theme.colors.blue4rentMarketing};
    display: inline-block;
    margin: 0;
    position: relative;
    font-weight: 700;
    &::after {
      content: "";
      background-image: url("/icons/heading-underline-blue-mobile.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      position: absolute;
      bottom: -4px;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 4px;
      z-index: 1;
    }
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 60px;
    font-weight: 400;
    line-height: 150%;
    strong {
      font-weight: 700;
      &::after {
        background-image: url("/icons/heading-underline-blue-desktop.svg");
      }
    }
  }
`

const StyledP = styled(NewText)`
  margin: 0;
  ${(props) => props.theme.breakpoints.up("md")} {
    letter-spacing: -0.48px;
  }
  font-family: var(--narkis) !important;
  * {
    margin: 0;
  }
`

type Props = {
  title?: string
  subTitle?: string
  isCentered?: boolean
  desktopMarginBottom?: number
  mobileMarginBottom?: number
  isSubTitleRichText?: boolean
}

const WhiteBgHeading = ({
  title,
  subTitle,
  isCentered = true,
  desktopMarginBottom,
  mobileMarginBottom,
  isSubTitleRichText = false,
}: Props) => {
  return (
    <StyledTextContent
      isCentered={isCentered}
      desktopMarginBottom={desktopMarginBottom}
      mobileMarginBottom={mobileMarginBottom}
    >
      {title && (
        <StyledHeading
          isCentered={isCentered}
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      )}
      {subTitle &&
        (isSubTitleRichText ? (
          <StyledP
            component="p"
            desktopFontSize={24}
            mobileFontSize={20}
            desktopLineHeight={"32px"}
            mobileLineHeight="130%"
            inheritColor
            color="inherit"
            desktopFontWeight={300}
            dangerouslySetInnerHTML={{ __html: subTitle }}
          />
        ) : (
          <StyledP
            component="p"
            desktopFontSize={24}
            mobileFontSize={20}
            desktopLineHeight={"150%"}
            mobileLineHeight="130%"
            inheritColor
            color="inherit"
            desktopFontWeight={300}
          >
            {subTitle}
          </StyledP>
        ))}
    </StyledTextContent>
  )
}
export default WhiteBgHeading
